import React from "react";
import Checkbox from "@mui/material/Checkbox";

const CheckboxView = (props) => {
  return (
    <Checkbox
      testid="check"
      checked={props.checked}
      onChange={(e) => props.onCheck(e)}
    />
  );
};

export default CheckboxView;
